import { render, staticRenderFns } from "./GenericBasicItemMaterialConfig.vue?vue&type=template&id=3724e02c&"
import script from "./GenericBasicItemMaterialConfig.vue?vue&type=script&lang=js&"
export * from "./GenericBasicItemMaterialConfig.vue?vue&type=script&lang=js&"
import style0 from "./GenericBasicItemMaterialConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports